import { render } from "./EntryList.vue?vue&type=template&id=48138874"
import script from "./EntryList.vue?vue&type=script&lang=js"
export * from "./EntryList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\VS2022\\kirchenbote-online-2022_01\\MD.RMP.KirchenboteOnline.Umb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/multiForms/EntryList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "48138874"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('48138874', __exports__)) {
    api.reload('48138874', __exports__)
  }
  
  module.hot.accept("./EntryList.vue?vue&type=template&id=48138874", () => {
    api.rerender('48138874', render)
  })

}


export default __exports__